export interface EupheusFaqEntry {
    question: string
    answer: string
}

/**
 * Single source of truth for the FAQ: the visible list and the FAQPage
 * structured data are both generated from this, so they can never drift
 * apart (Google treats schema that does not match the page as a violation).
 */
export const EUPHEUS_FAQ: EupheusFaqEntry[] = [
    {
        question: 'What is Eupheus?',
        answer: 'Eupheus is the AI study partner built into Just Enough Prep. You can ask it anything about your FSA Group & Health exam syllabus, and it answers by researching your actual course materials — the outlines, notecards, practice questions, and the underlying source material — rather than answering from memory.',
    },
    {
        question:
            'How is Eupheus different from asking ChatGPT about my actuarial exam?',
        answer: 'A general chatbot answers from whatever it absorbed during training, which is why it invents plausible-sounding formulas and cites readings that do not exist. Eupheus searches your specific course content before it answers, and links the exact notecard, outline section, or practice question behind every claim, so you can verify it in one click. It also knows which page you are on and can navigate you to the material it is describing.',
    },
    {
        question: 'Can Eupheus grade my practice questions?',
        answer: 'Yes. Hit Autograde on any practice question — or on an entire quiz or exam at once — and Eupheus grades every part against the official solution, awards points sub-part by sub-part, and explains exactly why you earned or missed each one. Every attempt is saved to a grading history you can revisit.',
    },
    {
        question: 'Does Eupheus grade Excel work?',
        answer: 'Yes. Upload the workbook you built from our Excel template and Eupheus grades it cell by cell against the official solution workbook. It hands back an annotated copy of your own spreadsheet with the problem cells highlighted in red, notes explaining what went wrong and how to fix each one, and a Grader Feedback summary sheet.',
    },
    {
        question: 'Can I have a back-and-forth conversation with Eupheus?',
        answer: 'Yes. Eupheus keeps unlimited conversations, names each one automatically, and lets you resume any of them later to pick up where you left off. Ask follow-up questions the way you would with a tutor.',
    },
    {
        question: 'Can Eupheus be wrong?',
        answer: 'Yes, and we would rather say so plainly. Eupheus grounds every answer in your course materials, but it is an AI and it can still make mistakes. That is exactly why every answer keeps its sources one click away — check anything that matters before you rely on it.',
    },
    {
        question: 'What will Eupheus not help with?',
        answer: 'Eupheus is a study partner for your course, not a general-purpose assistant. It will politely decline essay writing, coding homework, and anything else off-syllabus, and it only ever navigates within Just Enough Prep.',
    },
    {
        question: 'Is Eupheus included with a Just Enough Prep subscription?',
        answer: 'Yes. Eupheus is included with your course subscription at no extra cost, and is available from every page of the site once you are logged in.',
    },
]
